/* eslint-disable i18next/no-literal-string */
import { CustomerStory } from '@/components/carousel/ugc_reviews_carousel'

const copyContext = 'customer_stories.carousel'
const imgPathPrefix = 'customer-stories-carousel-slide-'
const customerStories: Array<CustomerStory> = [
  {
    path: `${imgPathPrefix}1`,
    alt: `${copyContext}.petra.alt`,
    header: `${copyContext}.petra.header`,
    text: [`${copyContext}.petra.text`]
  },
  {
    path: `${imgPathPrefix}2`,
    alt: `${copyContext}.rhaea.alt`,
    header: `${copyContext}.rhaea.header`,
    text: [`${copyContext}.rhaea.text_1`, `${copyContext}.rhaea.text_2`],
    fun_fact: `${copyContext}.rhaea.fun_fact`
  },
  {
    path: `${imgPathPrefix}3`,
    alt: `${copyContext}.jemma.alt`,
    header: `${copyContext}.jemma.header`,
    text: [`${copyContext}.jemma.text`],
    fun_fact: `${copyContext}.jemma.fun_fact`
  },
  {
    path: `${imgPathPrefix}4`,
    alt: `${copyContext}.barbara.alt`,
    header: `${copyContext}.barbara.header`,
    text: [
      `${copyContext}.barbara.text_1`,
      `${copyContext}.barbara.text_2`,
      `${copyContext}.barbara.text_3`
    ],
    fun_fact: `${copyContext}.barbara.fun_fact`
  },
  {
    path: `${imgPathPrefix}5`,
    alt: `${copyContext}.rebekah.alt`,
    header: `${copyContext}.rebekah.header`,
    text: [`${copyContext}.rebekah.text_1`, `${copyContext}.rebekah.text_2`],
    fun_fact: `${copyContext}.rebekah.fun_fact`
  },
  {
    path: `${imgPathPrefix}6`,
    alt: `${copyContext}.erika.alt`,
    header: `${copyContext}.erika.header`,
    text: [`${copyContext}.erika.text_1`, `${copyContext}.erika.text_2`],
    fun_fact: `${copyContext}.erika.fun_fact`,
    subscript: `${copyContext}.erika.subscript`
  }
]

export { customerStories }
